// Keep this glossary in sync with document_processing/word/bilingual_formatting.py.
export const MATH_TERM_PATTERNS = [
  "greatest\\s+common\\s+(?:divisors?|factors?)",
  "highest\\s+common\\s+factors?",
  "least\\s+common\\s+multiples?",
  "lowest\\s+common\\s+multiples?",
  "(?:relatively|mutually)\\s+prime",
  "co[-\\s]?prime",
  "prime\\s+factorizations?",
  "(?:Euclidean|division)\\s+algorithms?",
  "(?:remainder|factor)\\s+theorems?",
  "arithmetic\\s+(?:sequences?|progressions?|means?)",
  "geometric\\s+(?:sequences?|progressions?|means?)",
  "common\\s+(?:differences?|ratios?)",
  "(?:positive|negative|nonnegative|nonpositive)\\s+integers?",
  "(?:rational|irrational|real|natural|whole|prime|composite)\\s+numbers?",
  "(?:linear|quadratic|simultaneous)\\s+(?:equations?|functions?|inequalities)",
  "systems?\\s+of\\s+(?:linear\\s+)?equations?",
  "absolute\\s+values?",
  "perfect\\s+squares?",
  "square\\s+roots?",
  "cube\\s+roots?",
  "(?:right|acute|obtuse|isosceles|equilateral|similar|congruent)\\s+triangles?",
  "(?:right|acute|obtuse|central|inscribed|adjacent|vertical|interior|exterior)\\s+angles?",
  "(?:complementary|supplementary)\\s+angles?",
  "(?:perpendicular|angle)\\s+bisectors?",
  "(?:parallel|perpendicular)\\s+lines?",
  "(?:adjacent|opposite)\\s+sides?",
  "line\\s+segments?",
  "regular\\s+polygons?",
  "surface\\s+areas?",
  "coordinate\\s+(?:planes?|axes|systems?)",
  "(?:x|y)[-\\s]+(?:axes|axis|intercepts?)",
  "standard\\s+deviations?",
  "sample\\s+spaces?",
  "Pythagorean\\s+theorems?",
  "integers?",
  "fractions?",
  "numerators?",
  "denominators?",
  "decimals?",
  "percentages?",
  "ratios?",
  "proportions?",
  "factors?",
  "multiples?",
  "divisors?",
  "dividends?",
  "quotients?",
  "remainders?",
  "coefficients?",
  "constants?",
  "exponents?",
  "polynomials?",
  "monomials?",
  "binomials?",
  "equations?",
  "inequalit(?:y|ies)",
  "functions?",
  "variables?",
  "reciprocals?",
  "sequences?",
  "progressions?",
  "logarithms?",
  "triangles?",
  "quadrilaterals?",
  "parallelograms?",
  "rectangles?",
  "squares?",
  "rhomb(?:us|i|uses)",
  "trapezoids?",
  "trapezi(?:um|a)",
  "polygons?",
  "circles?",
  "radii|radius",
  "diameters?",
  "circumferences?",
  "arcs?",
  "chords?",
  "tangents?",
  "secants?",
  "angles?",
  "bisectors?",
  "altitudes?",
  "hypotenuses?",
  "midpoints?",
  "centroids?",
  "orthocenters?",
  "circumcenters?",
  "incenters?",
  "vert(?:ex|ices)",
  "diagonals?",
  "perimeters?",
  "areas?",
  "volumes?",
  "prisms?",
  "pyramids?",
  "cones?",
  "cylinders?",
  "spheres?",
  "coordinates?",
  "slopes?",
  "intercepts?",
  "asymptotes?",
  "probabilit(?:y|ies)",
  "permutations?",
  "combinations?",
  "means?",
  "medians?",
  "modes?",
  "ranges?",
  "sines?",
  "cosines?",
  "tangents?",
  "theorems?"
];

const boundaryPattern = (pattern) => new RegExp(`(?<![A-Za-z0-9_])(?:${pattern})(?![A-Za-z0-9_])`, "gi");
const escapePattern = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "\\s+");
const opaquePattern = /<(?:svg|figure|picture|math)\b[^>]*>[\s\S]*?<\/(?:svg|figure|picture|math)\s*>|https?:\/\/[^\s<>]+|data:[^\s<>]+|\\(?:text|mathrm|mathbf|mathit|operatorname)\s*\{(?:[^{}]|\{[^{}]*\})*\}|<!--[\s\S]*?-->|<\/?[A-Za-z][^>]*>/gi;

export const englishEmphasisSegments = (value, source = value, spans) => {
  const text = String(value || "");
  const opaque = Array.from(text.matchAll(opaquePattern), (match) => [match.index, match.index + match[0].length]);
  const patterns = Array.isArray(spans)
    ? spans.filter((span) => Number.isInteger(span.start) && Number.isInteger(span.end) && span.end > span.start)
      .map((span) => ({ pattern: escapePattern(Array.from(String(source || "")).slice(span.start, span.end).join("")),
        bold: Boolean(span.bold), underline: Boolean(span.underline) })).filter((item) => item.pattern)
    : [{ pattern: MATH_TERM_PATTERNS.join("|"), bold: true },
      { pattern: "(?:not\\s+)?(?:incorrect|correct)", underline: true }];
  const matches = patterns.flatMap((style) => Array.from(text.matchAll(boundaryPattern(style.pattern)), (match) => ({
    ...style, start: match.index, end: match.index + match[0].length,
  }))).filter((match) => !opaque.some(([start, end]) => start < match.end && end > match.start));
  const cuts = [...new Set([0, text.length, ...matches.flatMap((match) => [match.start, match.end])])].sort((left, right) => left - right);
  return cuts.slice(0, -1).map((start, index) => {
    const end = cuts[index + 1];
    const active = matches.filter((match) => match.start < end && match.end > start);
    return { text: text.slice(start, end), bold: active.some((match) => match.bold), underline: active.some((match) => match.underline) };
  });
};
